import React from "react";
import { Carousel } from "react-bootstrap";
import img1 from '../../../../images/NextProject2.png'
import img2 from '../../../../images/NextProject3.png'
import img3 from '../../../../images/NextProject4.png'
import img4 from '../../../../images/NextProject5.png'
import img5 from '../../../../images/NextProject6.png'
const Rondhan = () => {
  return (
    <div className="roadRiderzProject">
      <h1 className="projects-Header">RONDHAN</h1>
      <div className="row site-details-rrz">
        <div className="col-md-6 p-3">
          <p>
            * Rondhan is a Agriculture based website, it will become a farmer
            management system, my responsnsibilty in frontend.
          </p>
          <p>
            * This website help our Agriculture sector, farmer can farming with
            proper knowledge, support and equipment.
          </p>
          <p>* Technologies: NextJs, React Bootstrap, REST Api, Vercel.</p>
          <p>
            * Using Server Side Rendering(SSR), SSG all device responsive UI.
          </p>
          {/* <p>*Admin: AdminDashboard, AddBanner, AddAdmin, Chat with User, ManageOrders,
  ApproveTestimonials, Add new provider, and admin can manage all services.</p> */}

          {/* <p>* Also implement Authorization system </p> */}
          <div className="siteInfo">
        <h3 className="seeLive">See Live: </h3>
        <span>
          {" "}
          <a
            className="liveSite"
            target="_blank"
            href="https://rondhan.vercel.app/"
          >
            <b>LiveSite</b>
          </a>
        </span>
        <span>
          <a
            className="clientSide"
            target="_blank"
            href="https://github.com/Iasir-Arafat-riaz/Rondhan"
          >
            <b>ClientSideCode</b>
          </a>
        </span>
        {/* <span>
          <a className="serverSide" target="_blank" href="https://github.com/kawsarm104/service-assistant-a2z-backend"><b>ServerSideCode</b></a>
        </span> */}
      </div>
        </div>
        <div className="col-md-6 p-3">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={img1}
                alt="First slide"
              />
              <Carousel.Caption>
                {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={img2}
                alt="Second slide"
              />

              <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={img5}
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={img3}
                alt="Third slide"
              />

              <Carousel.Caption>
                
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={img4}
                alt="Third slide"
              />

              
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    
    </div>
  );
};

export default Rondhan;
